/* If the author already numbers headings ("1. Setup"), switch off the
   printed section counter so numbers aren't doubled. */
(function () {
    'use strict';

    var content = document.querySelector('[data-content]');
    if (!content) {
        return;
    }

    var numbered = Array.prototype.some.call(content.querySelectorAll(':scope > h2'), function (h) {
        return /^\s*\d+[.)]\s+/.test(h.textContent);
    });

    if (numbered) {
        content.setAttribute('data-manual-numbers', '');
    }
})();
